import { DatePicker } from "@kitbird/core";
import styled from "styled-components";

export const CustomDatePicker = styled(DatePicker).attrs({
  className: "date-picker-container",
})`
  &.date-picker-container {
    display: flex;
    border: none;
    border-radius: 6px;
    background: rgb(242, 246, 251);
    padding: 0 0 0 .5rem;
    height: 40px;
    width: 270px;
  }
`;

export const DatePickerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F2F6FB;
  border-radius: 8px;
  height: 40px;
`;
